import { useState } from "react";
import { Image as ImageIcon } from "@phosphor-icons/react";
import { cn } from "@/lib/utils";

// Renders a generated asset from a Media Engine signed URL, with graceful
// fallbacks for missing/failed images (draft assets, expired tokens).
export function MediaImage({ url, alt, className, iconSize = 22, onLoaded }) {
  const [errored, setErrored] = useState(false);

  if (!url || errored) {
    return (
      <div
        className={cn("flex items-center justify-center bg-accent/40 text-muted-foreground", className)}
        data-testid="media-placeholder"
      >
        <ImageIcon size={iconSize} weight="duotone" />
      </div>
    );
  }
  return (
    <img
      src={url}
      alt={alt || "asset"}
      loading="lazy"
      onError={() => setErrored(true)}
      onLoad={(e) => onLoaded?.({ width: e.target.naturalWidth, height: e.target.naturalHeight })}
      className={className}
      data-testid="media-image"
    />
  );
}
